import type { BootstrapPayload, MenuEntry } from "../contracts";

// Resolve a model key → the first action whose `model_key` matches it. Used by
// the drill-stack renderer to take a `{modelKey, recordRef}` frame and figure
// out which action's view metadata (formPlan + fieldDefs) should render that
// record. The bootstrap payload already carries every action's `modelKey` via
// `MenuEntry.action.modelKey`, so this is a pure client-side walk — no extra
// roundtrip needed.
//
// Returns the action slug (i.e. `MenuEntry.action.key`) when a match exists,
// or null when no menu action targets the given model. The caller renders a
// graceful fallback ("No view registered for this model") in the null case.
export function findActionForModel(boot: BootstrapPayload | undefined, modelKey: string): string | null {
    if (!boot) return null;
    for (const entries of Object.values(boot.menus ?? {})) {
        const found = walk(entries, modelKey);
        if (found) return found;
    }
    return null;
}

function walk(entries: MenuEntry[], modelKey: string): string | null {
    for (const entry of entries) {
        const action = entry.action;
        if (action && action.modelKey === modelKey && action.key) {
            return action.key;
        }
        if (entry.children && entry.children.length > 0) {
            const found = walk(entry.children, modelKey);
            if (found) return found;
        }
    }
    return null;
}
